export function getNormalizedTestID(value: string) {
  if (!value) return

  return value
    .toUpperCase()
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/[^A-Z0-9 ]/g, '')
    .replace(/ /g, '_')
}
